import { Object3D } from "three"

export const equipRightHand = (Body: Object3D) => (element: Object3D) => {
  Body.traverse(n => {
    if (n.name === 'handSlotRight') {
      n.add(element)
    }
  })
}